import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from 'src/environments/environments';

@Injectable({ providedIn: 'root' })
export class LaundryService {

    private subject = new BehaviorSubject<string>('Initial Value')
    current = this.subject.asObservable()

    private arrayData = new BehaviorSubject([])
    currentArray = this.arrayData.asObservable()

    constructor(
        private router: Router,
        private http: HttpClient
    ) { }

    // catgeory
    addLaundryCategory(name: any, image: any) {
        const formData = new FormData();
        formData.append('name', name);
        if (image) {
            formData.append('image', image, image.name);
        }
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/laundry/category/add`, formData).pipe(map(user => {
            return user;
        }));
    }

    upadteLaundryCategory(id: any, name: any, image: any) {
        const formData = new FormData();
        formData.append('name', name);
        if (image) {
            formData.append('image', image, image.name);
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/laundry/category/update/${id}`, formData).pipe(map(user => {
            return user;
        }));
    }
    blockLaundry(id: any, status: any) {
        let formData =
        {
            'status': status
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/laundry/category/update/${id}`, formData).pipe(map(user => {
            return user;
        }));
    }
    getlaundryCategorylistbyId(id: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/laundry/category/getById/${id}`).pipe(map(user => user));
    }

    deleteLaundryCategory(id: any) {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/laundry/category/delete/` + id)
            .pipe(map((user) => {
                return user;
            }));
    }
    getLaundryCategoryList(page: any, search: any, status: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/laundry/category/list?search=` + search + '&page=' + page + '&status=' + status).pipe(map(user => user));
    }

    getLaundryCategoryDropDown() {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/laundry/category/dropdown`).pipe(map(user => user));
    }

    // Sub-category
    addLaundrysubCategory(name: any, categoryId: any, image: any) {
        const formData = new FormData();
        formData.append('name', name);
        formData.append('categoryId', categoryId);
        formData.append('image', image)
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/laundry/sub-category/add`, formData).pipe(map(user => {
            return user;
        }));
    }

    upadteLaundrysubCategory(id: any, name: any, categoryId: any, image: any) {
        const formData = new FormData();
        formData.append('name', name);
        formData.append('categoryId', categoryId);
        formData.append('image', image)
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/laundry/sub-category/update/${id}`, formData).pipe(map(user => {
            return user;
        }));
    }
    blockSubcategoryLaundry(id: any, status: any) {
        let formData =
        {
            'status': status
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/laundry/sub-category/update/${id}`, formData).pipe(map(user => {
            return user;
        }));
    }
    getlaundrysubCategorylistbyId(id: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/laundry/sub-category/getById/${id}`).pipe(map(user => user));
    }

    deleteLaundrysubCategory(id: any) {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/laundry/sub-category/delete/` + id)
            .pipe(map((user) => {
                return user;
            }));
    }
    getLaundrysubCategoryList(page: any, search: any, categoryId: any, status: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/laundry/sub-category/list?search=` + search + '&page=' + page + '&categoryId=' + categoryId + '&status=' + status).pipe(map(user => user));
    }

    getLaundrysubCategoryDropDown(categoryId: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/laundry/sub-category/dropdown?categoryId=` + categoryId).pipe(map(user => user));
    }

    // Laundry Item

    addLaundryItem(name: any, categoryId: any, subCategoryId: any, standardPrice: any, premiumPrice: any) {
        var formData = {
            'name': name,
            'categoryId': categoryId,
            'subCategoryId': subCategoryId,
            'standardPrice': standardPrice,
            'premiumPrice': premiumPrice
        }
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/laundry/item/add`, formData).pipe(map(user => {
            return user;
        }));
    }

    upadteLaundryItem(id: any, name: any, categoryId: any, subCategoryId: any, standardPrice: any, premiumPrice: any) {
        var formData = {
            'name': name,
            'categoryId': categoryId,
            'subCategoryId': subCategoryId,
            'standardPrice': standardPrice,
            'premiumPrice': premiumPrice
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/laundry/item/update/${id}`, formData).pipe(map(user => {
            return user;
        }));
    }
    blockLaundryItemService(id: any, status: any) {
        let formData =
        {
            'status': status
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/laundry/item/update/${id}`, formData).pipe(map(user => {
            return user;
        }));
    }
    getlaundryItemlistbyId(id: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/laundry/item/getById/${id}`).pipe(map(user => user));
    }

    deleteLaundrItem(id: any) {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/laundry/item/delete/` + id)
            .pipe(map((user) => {
                return user;
            }));
    }
    getLaundryItemLists(page: any, search: any, categoryId: any, subCategoryId: any, status: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/laundry/item/list?search=` + search + '&page=' + page + '&categoryId=' + categoryId + '&subCategoryId=' + subCategoryId + '&status=' + status).pipe(map(user => user));
    }
    getlaundryItemDropdown(categoryId: any,subCategoryId: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/laundry/item/dropdown?categoryId=` + categoryId +"&subCategoryId="+subCategoryId).pipe(map(user => user));
    }
    // Upload banner
    getbannerimage() {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/laundry/banner/list`).pipe(map(user => user));
    }

    uploadBannerImage(image: any) {
        const formData: FormData = new FormData();
        if (image) {
            formData.append('image', image, image.name);
        }
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/laundry/banner/add`, formData).pipe(map(user => {
            return user;
        }));
    }

    updateBannerImage(id: any, image: any) {
        const formData: FormData = new FormData();
        if (image) {
            formData.append('image', image, image.name);
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/laundry/banner/update/` + id, formData).pipe(map(user => {
            return user;
        }));
    }

    deleteBannerImage(id: any) {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/laundry/banner/delete/` + id).pipe(map(user => {
            return user;
        }));
    }

    //   Delivery
    orderDetails(orderStatus: any, search: any, page: any, fromDate: any, toDate: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/laundry/order/list?orderStatus=` + orderStatus + '&search=' + search + '&page=' + page + '&fromDate=' + fromDate + '&toDate=' + toDate).pipe(map(user => user));
    }

    ordeRDetails(orderStatus: any, search_invoiceNumber: any, search_userName: any, search_userContactNo: any, search_userEmail: any, page: any, fromDate: any, toDate: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/laundry/order/list?orderStatus=` + orderStatus + '&search_invoiceNumber=' + search_invoiceNumber + '&search_userName=' + search_userName + '&search_userContactNo=' + search_userContactNo + '&search_userEmail=' + search_userEmail+ '&page=' + page + '&fromDate=' + fromDate + '&toDate=' + toDate).pipe(map(user => user));
    }

    updateOrderStatus(id: any, orderStatus: any, rejectedReason: any) {
        var formData = {
            'orderStatus': orderStatus,
            'rejectedReason': rejectedReason
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/laundry/order/update-status/${id}`, formData).pipe(map(user => {
            return user;
        }));
    }

    settelmentDetails(paidStatus: any, search_invoiceNumber: any, search_userName: any, search_userContactNo: any, search_userEmail: any, page: any, fromDate: any, toDate: any,driverId: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/laundry/settlement/list?paidStatus=` + paidStatus + '&search_invoiceNumber=' + search_invoiceNumber + '&search_userName=' + search_userName + '&search_userContactNo=' + search_userContactNo + '&search_userEmail=' + search_userEmail+ '&page=' + page + '&fromDate=' + fromDate + '&toDate=' + toDate + '&driverId=' + driverId).pipe(map(user => user));
    }

    paidStatusUpdate(id: any) {
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/laundry/settlement/settlement/${id}`,{});
    }

     getDriverDropdown() {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/laundry/staff/dropdown?isDriver=` + 1).pipe(map(user => user));
    }

    getNewDeliveryCount() {
        return this.http
            .get<any>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/laundry/order/count`
            )
            .pipe(map((user) => user));
    }
    getOrderDetailsByID(id: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/laundry/order/viewById/${id}`).pipe(map(user => user));
    }
    updatelaundryOrderStatus(id: any, orderStatus: any, pickupDate: any, pickupTime: any, deliveryDate: any, deliveryTime: any
    ) {
        var formData = {
            'orderStatus': orderStatus,
            'pickupDate': pickupDate,
            'pickupTime': pickupTime,
            'deliveryDate': deliveryDate,
            'deliveryTime': deliveryTime
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/laundry/order/update-status/${id}`, formData).pipe(map(user => {
            return user;
        }));
    }

    getDriverList(): Observable<any> {
        return this.http.get(`${environment.apiUrl}${environment.apiPrefix}/laundry/driver/list`);
    }

    assignSingleDriver(orderId: string, driverId: string, acceptedStatus: number): Observable<any> {
        const payload = {
            order_id: orderId,
            driver_id: driverId,
            accepted_status: acceptedStatus
        };
        return this.http.put(`${environment.apiUrl}${environment.apiPrefix}/admin/laundry/order/update-accepted-status`, payload);
    }

    assignAllDrivers(orderId: string, driverIds: string[],aprtPickupDate?: any,aprtPickupTime? :any): Observable<any> {
        const payload = {
            order_id: orderId,
            assigned_driver: driverIds,
            aprtPickupDate: aprtPickupDate,
            aprtPickupTime: aprtPickupTime
        };
        return this.http.put(`${environment.apiUrl}${environment.apiPrefix}/admin/laundry/order/assign-drivers`, payload);
    }

    updateOrderStatusOnly(orderId: string, orderStatus: number,deliveryDate?: string,deliveryTime?: string): Observable<any> {
        const payload = {
            orderStatus: orderStatus,
            deliveryDate: deliveryDate || '',
            deliveryTime: deliveryTime || ''
        };
        
        return this.http.put(`${environment.apiUrl}${environment.apiPrefix}/admin/laundry/order/update-status/${orderId}`, payload);
    }


    categoryExcelUpload(file: any) {
        const formData = new FormData();
        formData.append("file", file);
        return this.http
            .post<any>(
                `${environment.apiUrl}${environment.apiPrefix}/laundry/excel/categoryUpload`,
                formData
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    downloadCategoryExcel() {
        const file = this.http
            .get<Blob>(
                `${environment.apiUrl}${environment.apiPrefix}/laundry/excel/categoryexcelDownload`,
                { responseType: "blob" as "json" }
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
        return file;
    }


    subcategoryExcelUpload(file: any) {
        const formData = new FormData();
        formData.append("file", file);
        return this.http
            .post<any>(
                `${environment.apiUrl}${environment.apiPrefix}/laundry/excel/subcategoryUpload`,
                formData
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    downloadSubCategoryExcel() {
        const file = this.http
            .get<Blob>(
                `${environment.apiUrl}${environment.apiPrefix}/laundry/excel/subcategoryexcelDownload`,
                { responseType: "blob" as "json" }
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
        return file;
    }


    itemExcelUpload(file: any, laundryId: any) {
        const formData = new FormData();
        formData.append("file", file);
        return this.http
            .post<any>(
                `${environment.apiUrl}${environment.apiPrefix}/laundry/excel/itemUpload?laundryId=` + laundryId,
                formData
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    downloaditemExcel() {
        const file = this.http
            .get<Blob>(
                `${environment.apiUrl}${environment.apiPrefix}/laundry/excel/itemDownload`,
                { responseType: "blob" as "json" }
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
        return file;
    }
    // Get permission - Staff
    getStaffUsers(page: any, search: any, status: any) {
        return this.http
            .get<any>(
                `${environment.apiUrl}${environment.apiPrefix}/laundry/staff/list?page=` +
                page +
                "&search=" +
                search +
                "&status=" +
                status
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    createStaff(formData: FormData) {
        return this.http
            .post<any>(
                `${environment.apiUrl}${environment.apiPrefix}/laundry/staff/add`,
                formData
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }
    
    deleteStaffUser(id: any) {
        return this.http
            .delete<any>(
                `${environment.apiUrl}${environment.apiPrefix}/laundry/staff/delete/` +
                id
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    viewStaffUsersbyId(id: any) {
        return this.http
            .get<any>(
                `${environment.apiUrl}${environment.apiPrefix}/laundry/staff/viewById/` +
                id
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }
    updatepassword(id: any, newPassword: any, confirmPassword: any) {
        const formData = {
            newPassword: newPassword,
            confirmPassword: confirmPassword
        };
        return this.http
            .put<any>(
                `${environment.apiUrl}${environment.apiPrefix}/laundry/staff/update-password/` +
                id,
                formData
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }
    updateStaff(staffId: any, formData: FormData) {
        return this.http
            .put<any>(
                `${environment.apiUrl}${environment.apiPrefix}/laundry/staff/update/${staffId}`,
                formData
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    blockStaffUser(id: any, name: any, username: any, status: any) {
        let formData =
        {
            name: name,
            username: username,
            status: status
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/laundry/staff/update/` + id, formData)
            .pipe(map((user) => {
                return user;
            }));
    }
    // Report
    LaundryReport(page: any, search: any, startDate: any, endDate: any, categoryId: any, subCategoryId: any, itemId: any) {
        return this.http
            .get<any>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/reports/laundry/list?page=` +
                page +
                "&search=" +
                search +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&subCategoryId="
                + subCategoryId +
                "&categoryId="
                + categoryId +
                "&itemId="
                + itemId

            )
            .pipe(
                map((user) => {
                    return user;
                })
            );

    }
    downloadLaundryGenerationExcel(startDate: any, endDate: any,categoryId: any, subCategoryId: any, itemId: any) {
        const file = this.http
            .get<Blob>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/reports/laundry/download?startDate=` +
                startDate +
                "&endDate=" +
                endDate +
                 "&categoryId=" +
                categoryId +
                "&subCategoryId="
                + subCategoryId +
                "&itemId="
                + itemId,
                { responseType: "blob" as "json" }
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
        return file;
    }
    downloadlaundryExcel(startDate: any, endDate: any) {
        const file = this.http
            .get<Blob>(
                `${environment.apiUrl}${environment.apiPrefix}/laundry/excel/downloadDeliveredOrder?startDate=` +
                startDate +
                "&endDate=" +
                endDate,

                { responseType: "blob" as "json" }
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
        return file;
    }



    downloadLaundrydeliveryExeclFormat(fromDate: any, toDate: any, search: any) {
        const file = this.http
            .get<Blob>(
                `${environment.apiUrl}${environment.apiPrefix}/laundry/excel/downloadDeliveredOrder?fromDate=` +
                fromDate +
                "&toDate=" +
                toDate +
                "&search=" + search,

                { responseType: "blob" as "json" }
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
        return file;
    }

    // Weekly Timings
    getWeeklyTimings() {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/laundry/operating-timings`).pipe(map(res => res));
    }

    saveWeeklyTimings(payload: any) {
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/laundry/operating-timings`, payload).pipe(map(res => res));
    }

    updateWeeklyTimings(payload: any) {
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/laundry/operating-timings`, payload).pipe(map(res => res));
    }

    // Status Change
    laundryStatusChange(status: any) {
        let formData =
        {
            'status': status
        }
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/laundry/statusUpdate`, formData).pipe(map(user => {
            return user;
        }));
    }

    // Coupon
    createLaundryCoupon(formData: FormData) {
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/laundry/coupon/create`, formData).pipe(map(user => user));
    }

    getLaundryCouponList(page: any, search: any, status: any, from: string = '', to: string = '') {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/laundry/coupon/list?page=${page}&search=${search}&status=${status}&from=${from}&to=${to}`).pipe(map(user => user));
    }

    getLaundryCouponById(id: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/laundry/coupon/getById/${id}`).pipe(map(user => user));
    }

    updateLaundryCoupon(id: any, formData: FormData) {
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/laundry/coupon/update/${id}`, formData).pipe(map(user => user));
    }

    deleteLaundryCoupon(id: any) {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/laundry/coupon/delete/${id}`).pipe(map(user => user));
    }

    updateLaundryCouponStatus(id: any, status: any) {
        const formData = { status };
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/laundry/coupon/update/${id}`, formData).pipe(map(user => user));
    }

    downloadLaundryCouponUsageReport(from: string, to: string, search: any, status: any) {
        return this.http.get(`${environment.apiUrl}${environment.apiPrefix}/laundry/coupon/usage-report?from=${from}&to=${to}&search=${search}&status=${status}`, { responseType: 'blob' });
    }

    getLaundryItemDropdown(categoryId: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/laundry/item/dropdown?categoryId=${categoryId}`).pipe(map(user => user));
    }

    getVendorSettlementList(page: number, limit: number, fromDate: string, toDate: string, vendorType: string, vendorId: string) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/vendor-settlements/list?page=${page}&limit=${limit}&fromDate=${fromDate}&toDate=${toDate}&vendorType=${vendorType}&vendorId=${vendorId}`).pipe(map(user => user));
    }

    getVendorSettlementDetail(vendorType: string, vendorId: string, fromDate: string, toDate: string) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/vendor-settlements/detail/${vendorType}/${vendorId}?fromDate=${fromDate}&toDate=${toDate}`).pipe(map(user => user));
    }
}